import { DraggableResizableHeaderContent } from './DraggableResizableHeaderContent';
import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentComponent = /*#__PURE__*/memo(({
  column: {
    columnNamespace,
    columnName,
    resizable,
    reorderable
  },
  originalWidth,
  columnIndex,
  handleResize,
  onResizeEnd,
  onColumnOrderChange,
  arrowsNode,
  children
}) => /*#__PURE__*/_jsx(DraggableResizableHeaderContent, {
  arrowsNode: arrowsNode,
  columnNamespace: columnNamespace,
  columnName: columnName,
  columnIndex: columnIndex,
  onColumnOrderChange: onColumnOrderChange,
  handleResize: handleResize,
  onResizeEnd: onResizeEnd,
  originalWidth: originalWidth,
  reorderable: reorderable,
  resizable: resizable,
  children: children
}));